module.exports = __webpack_public_path__ + "static/img/hot66.1b9ad67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xiangyun/hot66.jpg
// module id = eg60
// module chunks = 1